import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getBatchInfo, getBatchDetails, getProjectDetails, saveBatchDetails, saveProjectMasterDetails, getAllCandidates, getProjectBatchInfo, removeBatchMaster, removeProjectMaster, saveSpecialisation, deleteDegree, getAllSpecialisation, getSpecialisation, saveSubject, getAllSubject, getSubject, getAllGroup, saveGroup, getGroup, saveCourse, getAllCourse, getCourse, deleteCourse, deleteSpecialization, deleteSubject, deleteGroup, deleteCourseSpec, saveSyllabus, getSyllabus, deleteSyllabus, getPublicCourse } from '../actions/masterDataAction';

interface MasterState {
    loading: boolean;
    success: boolean;
    error: any;
    batchInfo: any;
    loading1: boolean;
    success1: boolean;
    error1: any;
    saveBatchInfo: any;
    //project master
    loading2: boolean;
    success2: boolean;
    error2: any;
    projectInfo: any;
    loading3: boolean;
    success3: boolean;
    error3: any;
    saveProjectInfo: any;
    //get individual batch data
    loading4: boolean;
    error4: any;
    success4: boolean;
    indvBatchInfo: any;
    loading5: boolean;
    error5: any;
    success5: boolean;
    allCandidInfo: any;
    //get project batch info
    loading6: boolean;
    error6: any;
    success6: boolean;
    indvPrjBtchInfo: any;
    //remove batch & project
    loading7: boolean;
    error7: any;
    success7: boolean;
    rmvBatchInfo: any;
    loading8: boolean;
    error8: any;
    success8: boolean;
    rmvPrjInfo: any;
    loading9: boolean;
    error9: any;
    success9: boolean;
    saveSpecInfo: any;
    loading10: boolean;
    success10: boolean;
    error10: any;
    delDegInfo: any;
    loading11: boolean;
    success11: boolean;
    error11: any;
    specmasInfo: any;
    loading12: boolean;
    error12: any;
    success12: boolean;
    specialisationInfo: any;
    //subject master
    loading13: boolean;
    error13: any;
    success13: boolean;
    saveSubjInfo: any;
    loading14: boolean;
    error14: any;
    success14: boolean;
    subjectmasInfo: any;
    loading15: boolean;
    success15: boolean;
    error15: any;
    subjectInfo: any;
    //group category it/core
    loading16: boolean;
    success16: boolean;
    error16: any;
    saveCategoryInfo: any;
    loading17: boolean;
    error17: any,
    success17: boolean;
    categorymasInfo: any;
    loading18: boolean;
    success18: boolean;
    error18: any;
    categoryInfo: any;
    //course master
    loading19: boolean;
    error19: any;
    success19: boolean;
    saveCourseInfo: any;
    loading20: boolean;
    error20: any;
    success20: boolean;
    coursemasInfo: any;
    loading21: boolean;
    error21: any;
    success21: boolean;
    courseInfo: any;
    //delete configuration
    loading22: boolean;
    error22: any;
    success22: boolean;
    delCourseInfo: any;
    loading23: boolean;
    error23: any;
    success23: boolean;
    delSpecInfo: any;
    loading24: boolean;
    error24: any;
    success24: any;
    delSubjInfo: any;
    loading25: boolean;
    success25: boolean;
    error25: any;
    delCatInfo: any;
    loading26: boolean;
    error26: any;
    success26: boolean;
    delCourseSpec: any;
    //syllabus
    error27: any;
    success27: boolean;
    loading27: boolean;
    saveSyllInfo: any;
    loading28: boolean;
    error28: any;
    success28: boolean;
    syllabusInfo: any;
    loading29: boolean;
    error29: any;
    success29: boolean;
    delSyllInfo: any;
    loading30: boolean;
    error30: any;
    success30: boolean;
    pubCourseInfo: any;
}

const initialState: MasterState = {
    loading: false,
    success: false,
    error: null,
    batchInfo: null,
    loading1: false,
    success1: false,
    error1: null,
    saveBatchInfo: null,
    loading2: false,
    success2: false,
    projectInfo: null,
    error2: null,
    loading3: false,
    success3: false,
    saveProjectInfo: null,
    error3: null,
    loading4: false,
    error4: null,
    indvBatchInfo: null,
    success4: false,
    loading5: false,
    error5: null,
    success5: false,
    allCandidInfo: null,
    loading6: false,
    error6: null,
    success6: false,
    indvPrjBtchInfo: null,
    //remove batch & project
    loading7: false,
    error7: null,
    success7: false,
    rmvBatchInfo: null,
    loading8: false,
    error8: null,
    success8: false,
    rmvPrjInfo: null,
    loading9: false,
    error9: null,
    success9: false,
    saveSpecInfo: null,
    loading10: false,
    error10: null,
    success10: false,
    delDegInfo: null,
    loading11: false,
    error11: null,
    success11: false,
    specmasInfo: null,
    loading12: false,
    error12: null,
    success12: false,
    specialisationInfo: null,
    //subject master
    loading13: false,
    error13: null,
    success13: false,
    saveSubjInfo: null,
    loading14: false,
    error14: null,
    success14: false,
    subjectmasInfo: null,
    loading15: false,
    error15: null,
    success15: false,
    subjectInfo: null,
    //group category
    loading16: false,
    error16: null,
    success16: false,
    saveCategoryInfo: null,
    loading17: false,
    error17: null,
    success17: false,
    categorymasInfo: null,
    loading18: false,
    error18: null,
    success18: false,
    categoryInfo: null,
    //course master
    loading19: false,
    error19: null,
    success19: false,
    saveCourseInfo: null,
    loading20: false,
    error20: null,
    success20: false,
    coursemasInfo: null,
    loading21: false,
    error21: null,
    success21: false,
    courseInfo: null,
    //delete
    loading22: false,
    error22: null,
    success22: false,
    delCourseInfo: null,
    loading23: false,
    error23: null,
    success23: false,
    delSpecInfo: null,
    loading24: false,
    error24: null,
    success24: false,
    delSubjInfo: null,
    loading25: false,
    error25: null,
    success25: false,
    delCatInfo: null,
    loading26: false,
    error26: null,
    success26: false,
    delCourseSpec: null,
    loading27: false,
    error27: null,
    success27: false,
    saveSyllInfo: null,
    loading28: false,
    error28: null,
    success28: false,
    syllabusInfo: null,
    loading29: false,
    error29: null,
    success29: false,
    delSyllInfo: null,
    loading30: false,
    error30: null,
    success30: false,
    pubCourseInfo: null,
};

const masterSlice = createSlice({
    name: 'exam',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // questionpaper user
        builder
            .addCase(getBatchDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.batchInfo = null;
            })
            .addCase(getBatchDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.batchInfo = payload;
                state.success = true;
            })
            .addCase(getBatchDetails.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
                state.success = false;
            })
            .addCase(saveBatchDetails.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
                state.saveBatchInfo = null;
            })
            .addCase(saveBatchDetails.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.saveBatchInfo = payload;
                state.success1 = true;
            })
            .addCase(saveBatchDetails.rejected, (state, { payload }) => {
                state.loading1 = false;
                state.error1 = payload;
                state.success1 = false;
            })
            .addCase(getProjectDetails.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
                state.projectInfo = null;
            })
            .addCase(getProjectDetails.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.projectInfo = payload;
                state.success2 = true;
            })
            .addCase(getProjectDetails.rejected, (state, { payload }) => {
                state.loading2 = false;
                state.error2 = payload;
                state.success2 = false;
            })
            .addCase(saveProjectMasterDetails.pending, (state) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
                state.saveProjectInfo = null;
            })
            .addCase(saveProjectMasterDetails.fulfilled, (state, { payload }) => {
                state.loading3 = false;
                state.saveProjectInfo = payload;
                state.success3 = true;
            })
            .addCase(saveProjectMasterDetails.rejected, (state, { payload }) => {
                state.loading3 = false;
                state.error3 = payload;
                state.success3 = false;
            })
            .addCase(getBatchInfo.pending, (state) => {
                state.loading4 = true;
                state.error4 = null;
                state.success4 = false;
                state.indvBatchInfo = null;
            })
            .addCase(getBatchInfo.fulfilled, (state, { payload }) => {
                state.loading4 = false;
                state.indvBatchInfo = payload;
                state.success4 = true;
            })
            .addCase(getBatchInfo.rejected, (state, { payload }) => {
                state.loading4 = false;
                state.error4 = payload;
                state.success4 = false;
            })
            .addCase(getAllCandidates.pending, (state) => {
                state.loading5 = true;
                state.error5 = null;
                state.success5 = false;
                state.allCandidInfo = null;
            })
            .addCase(getAllCandidates.fulfilled, (state, { payload }) => {
                state.loading5 = false;
                state.allCandidInfo = payload;
                state.success5 = true;
            })
            .addCase(getAllCandidates.rejected, (state, { payload }) => {
                state.loading5 = false;
                state.error5 = payload;
                state.success5 = false;
            })
            .addCase(getProjectBatchInfo.pending, (state) => {
                state.loading6 = true;
                state.error6 = null;
                state.success6 = false;
                state.indvPrjBtchInfo = null;
            })
            .addCase(getProjectBatchInfo.fulfilled, (state, { payload }) => {
                state.loading6 = false;
                state.indvPrjBtchInfo = payload;
                state.success6 = true;
            })
            .addCase(getProjectBatchInfo.rejected, (state, { payload }) => {
                state.loading6 = false;
                state.error6 = payload;
                state.success6 = false;
            })
            .addCase(removeBatchMaster.pending, (state) => {
                state.loading7 = true;
                state.error7 = null;
                state.success7 = false;
                state.rmvBatchInfo = null;
            })
            .addCase(removeBatchMaster.fulfilled, (state, { payload }) => {
                state.loading7 = false;
                state.rmvBatchInfo = payload;
                state.success7 = true;
            })
            .addCase(removeBatchMaster.rejected, (state, { payload }) => {
                state.loading7 = false;
                state.error7 = payload;
                state.success7 = false;
            })
            .addCase(removeProjectMaster.pending, (state) => {
                state.loading8 = true;
                state.error8 = null;
                state.success8 = false;
                state.rmvPrjInfo = null;
            })
            .addCase(removeProjectMaster.fulfilled, (state, { payload }) => {
                state.loading8 = false;
                state.rmvPrjInfo = payload;
                state.success8 = true;
            })
            .addCase(removeProjectMaster.rejected, (state, { payload }) => {
                state.loading8 = false;
                state.error8 = payload;
                state.success8 = false;
            })
            .addCase(saveSpecialisation.pending, (state) => {
                state.loading9 = true;
                state.error9 = null;
                state.success9 = false;
                state.saveSpecInfo = null;
            })
            .addCase(saveSpecialisation.fulfilled, (state, { payload }) => {
                state.loading9 = false;
                state.saveSpecInfo = payload;
                state.success9 = true;
            })
            .addCase(saveSpecialisation.rejected, (state, { payload }) => {
                state.loading9 = false;
                state.error9 = payload;
                state.success9 = false;
            })
            .addCase(deleteDegree.pending, (state) => {
                state.loading10 = true;
                state.error10 = null;
                state.success10 = false;
                state.delDegInfo = null;
            })
            .addCase(deleteDegree.fulfilled, (state, { payload }) => {
                state.loading10 = false;
                state.delDegInfo = payload;
                state.success10 = true;
            })
            .addCase(deleteDegree.rejected, (state, { payload }) => {
                state.loading10 = false;
                state.error10 = payload;
                state.success10 = false;
            })
            .addCase(getAllSpecialisation.pending, (state) => {
                state.loading11 = true;
                state.error11 = null;
                state.success11 = false;
                state.specmasInfo = null;
            })
            .addCase(getAllSpecialisation.fulfilled, (state, { payload }) => {
                state.loading11 = false;
                state.specmasInfo = payload;
                state.success11 = true;
            })
            .addCase(getAllSpecialisation.rejected, (state, { payload }) => {
                state.loading11 = false;
                state.error11 = payload;
                state.success11 = false;
            })
            .addCase(getSpecialisation.pending, (state) => {
                state.loading12 = true;
                state.error12 = null;
                state.success12 = false;
                state.specialisationInfo = null;
            })
            .addCase(getSpecialisation.fulfilled, (state, { payload }) => {
                state.loading12 = false;
                state.specialisationInfo = payload;
                state.success12 = true;
            })
            .addCase(getSpecialisation.rejected, (state, { payload }) => {
                state.loading12 = false;
                state.error12 = payload;
                state.success12 = false;
            })
            .addCase(saveSubject.pending, (state) => {
                state.loading13 = true;
                state.error13 = null;
                state.success13 = false;
                state.saveSubjInfo = null;
            })
            .addCase(saveSubject.fulfilled, (state, { payload }) => {
                state.loading13 = false;
                state.saveSubjInfo = payload;
                state.success13 = true;
            })
            .addCase(saveSubject.rejected, (state, { payload }) => {
                state.loading13 = false;
                state.error13 = payload;
                state.success13 = false;
            })
            .addCase(getAllSubject.pending, (state) => {
                state.loading14 = true;
                state.error14 = null;
                state.success14 = false;
                state.subjectmasInfo = null;
            })
            .addCase(getAllSubject.fulfilled, (state, { payload }) => {
                state.loading14 = false;
                state.subjectmasInfo = payload;
                state.success14 = true;
            })
            .addCase(getAllSubject.rejected, (state, { payload }) => {
                state.loading14 = false;
                state.error14 = payload;
                state.success14 = false;
            })
            .addCase(getSubject.pending, (state) => {
                state.loading15 = true;
                state.error15 = null;
                state.success15 = false;
                state.subjectInfo = null;
            })
            .addCase(getSubject.fulfilled, (state, { payload }) => {
                state.loading15 = false;
                state.subjectInfo = payload;
                state.success15 = true;
            })
            .addCase(getSubject.rejected, (state, { payload }) => {
                state.loading15 = false;
                state.error15 = payload;
                state.success15 = false;
            })
            .addCase(saveGroup.pending, (state) => {
                state.loading16 = true;
                state.error16 = null;
                state.success16 = false;
                state.saveCategoryInfo = null;
            })
            .addCase(saveGroup.fulfilled, (state, { payload }) => {
                state.loading16 = false;
                state.saveCategoryInfo = payload;
                state.success16 = true;
            })
            .addCase(saveGroup.rejected, (state, { payload }) => {
                state.loading16 = false;
                state.error16 = payload;
                state.success16 = false;
            })
            .addCase(getAllGroup.pending, (state) => {
                state.loading17 = true;
                state.error17 = null;
                state.success17 = false;
                state.categorymasInfo = null;
            })
            .addCase(getAllGroup.fulfilled, (state, { payload }) => {
                state.loading17 = false;
                state.categorymasInfo = payload;
                state.success17 = true;
            })
            .addCase(getAllGroup.rejected, (state, { payload }) => {
                state.loading17 = false;
                state.error17 = payload;
                state.success17 = false;
            })
            .addCase(getGroup.pending, (state) => {
                state.loading18 = true;
                state.error18 = null;
                state.success18 = false;
                state.categoryInfo = null;
            })
            .addCase(getGroup.fulfilled, (state, { payload }) => {
                state.loading18 = false;
                state.categoryInfo = payload;
                state.success18 = true;
            })
            .addCase(getGroup.rejected, (state, { payload }) => {
                state.loading18 = false;
                state.error18 = payload;
                state.success18 = false;
            })
            .addCase(saveCourse.pending, (state) => {
                state.loading19 = true;
                state.error19 = null;
                state.success19 = false;
                state.saveCourseInfo = null;
            })
            .addCase(saveCourse.fulfilled, (state, { payload }) => {
                state.loading19 = false;
                state.saveCourseInfo = payload;
                state.success19 = true;
            })
            .addCase(saveCourse.rejected, (state, { payload }) => {
                state.loading19 = false;
                state.error19 = payload;
                state.success19 = false;
            })
            .addCase(getAllCourse.pending, (state) => {
                state.loading20 = true;
                state.error20 = null;
                state.success20 = false;
                state.coursemasInfo = null;
            })
            .addCase(getAllCourse.fulfilled, (state, { payload }) => {
                state.loading20 = false;
                state.coursemasInfo = payload;
                state.success20 = true;
            })
            .addCase(getAllCourse.rejected, (state, { payload }) => {
                state.loading20 = false;
                state.error20 = payload;
                state.success20 = false;
            })
            .addCase(getCourse.pending, (state) => {
                state.loading21 = true;
                state.error21 = null;
                state.success21 = false;
                state.courseInfo = null;
            })
            .addCase(getCourse.fulfilled, (state, { payload }) => {
                state.loading21 = false;
                state.courseInfo = payload;
                state.success21 = true;
            })
            .addCase(getCourse.rejected, (state, { payload }) => {
                state.loading21 = false;
                state.error21 = payload;
                state.success21 = false;
            })
            .addCase(deleteCourse.pending, (state) => {
                state.loading22 = true;
                state.error22 = null;
                state.success22 = false;
                state.delCourseInfo = null;
            })
            .addCase(deleteCourse.fulfilled, (state, { payload }) => {
                state.loading22 = false;
                state.delCourseInfo = payload;
                state.success22 = true;
            })
            .addCase(deleteCourse.rejected, (state, { payload }) => {
                state.loading22 = false;
                state.error22 = payload;
                state.success22 = false;
            })
            .addCase(deleteSpecialization.pending, (state) => {
                state.loading23 = true;
                state.error23 = null;
                state.success23 = false;
                state.delSpecInfo = null;
            })
            .addCase(deleteSpecialization.fulfilled, (state, { payload }) => {
                state.loading23 = false;
                state.delSpecInfo = payload;
                state.success23 = true;
            })
            .addCase(deleteSpecialization.rejected, (state, { payload }) => {
                state.loading23 = false;
                state.error23 = payload;
                state.success23 = false;
            })
            .addCase(deleteSubject.pending, (state) => {
                state.loading24 = true;
                state.error24 = null;
                state.success24 = false;
                state.delSubjInfo = null;
            })
            .addCase(deleteSubject.fulfilled, (state, { payload }) => {
                state.loading24 = false;
                state.delSubjInfo = payload;
                state.success24 = true;
            })
            .addCase(deleteSubject.rejected, (state, { payload }) => {
                state.loading24 = false;
                state.error24 = payload;
                state.success24 = false;
            })
            .addCase(deleteGroup.pending, (state) => {
                state.loading25 = true;
                state.error25 = null;
                state.success25 = false;
                state.delCatInfo = null;
            })
            .addCase(deleteGroup.fulfilled, (state, { payload }) => {
                state.loading25 = false;
                state.delCatInfo = payload;
                state.success25 = true;
            })
            .addCase(deleteGroup.rejected, (state, { payload }) => {
                state.loading25 = false;
                state.error25 = payload;
                state.success25 = false;
            })
            .addCase(deleteCourseSpec.pending, (state) => {
                state.loading26 = true;
                state.error26 = null;
                state.success26 = false;
                state.delCourseSpec = null;
            })
            .addCase(deleteCourseSpec.fulfilled, (state, { payload }) => {
                state.loading26 = false;
                state.delCourseSpec = payload;
                state.success26 = true;
            })
            .addCase(deleteCourseSpec.rejected, (state, { payload }) => {
                state.loading26 = false;
                state.error26 = payload;
                state.success26 = false;
            })
            .addCase(saveSyllabus.pending, (state) => {
                state.loading27 = true;
                state.error27 = null;
                state.success27 = false;
                state.saveSyllInfo = null;
            })
            .addCase(saveSyllabus.fulfilled, (state, { payload }) => {
                state.loading27 = false;
                state.saveSyllInfo = payload;
                state.success27 = true;
            })
            .addCase(saveSyllabus.rejected, (state, { payload }) => {
                state.loading27 = false;
                state.error27 = payload;
                state.success27 = false;
            })
            .addCase(getSyllabus.pending, (state) => {
                state.loading28 = true;
                state.error28 = null;
                state.success28 = false;
                state.syllabusInfo = null;
            })
            .addCase(getSyllabus.fulfilled, (state, { payload }) => {
                state.loading28 = false;
                state.syllabusInfo = payload;
                state.success28 = true;
            })
            .addCase(getSyllabus.rejected, (state, { payload }) => {
                state.loading28 = false;
                state.error28 = payload;
                state.success28 = false;
            })
            .addCase(deleteSyllabus.pending, (state) => {
                state.loading29 = true;
                state.error29 = null;
                state.success29 = false;
                state.delSyllInfo = null;
            })
            .addCase(deleteSyllabus.fulfilled, (state, { payload }) => {
                state.loading29 = false;
                state.delSyllInfo = payload;
                state.success29 = true;
            })
            .addCase(deleteSyllabus.rejected, (state, { payload }) => {
                state.loading29 = false;
                state.error29 = payload;
                state.success29 = false;
            })
            .addCase(getPublicCourse.pending, (state) => {
                state.loading30 = true;
                state.error30 = null;
                state.success30 = false;
                state.pubCourseInfo = null;
            })
            .addCase(getPublicCourse.fulfilled, (state, { payload }) => {
                state.loading30 = false;
                state.pubCourseInfo = payload;
                state.success30 = true;
            })
            .addCase(getPublicCourse.rejected, (state, { payload }) => {
                state.loading30 = false;
                state.error30 = payload;
                state.success30 = false;
            });
    },
});

export default masterSlice.reducer;
